import React from "react";
import Header from "./Header";
import Accordion from "./Accordion";

function FAQ() {
  const accordionData = [
    {
      title: "What is Dev Colony?",
      content: `Dev Colony is a diverse community of passionate developer mentors.`,
    },
    {
      title: "Why mentor on Dev Colony?",
      content: `We make mentoring easier by putting all the information out there in the public. Being a mentor encourages and enables another person's professional or personal development. Dev colony provides the audience with a high level of enthusiasm towards learning and achieving their career goals.`,
    },
    {
      title: "How much does it cost to book a mentor?",
      content: `There will no charges by Dev Colony on booking any mentor.`,
    },
    {
      title: "How to get invitation as a Mentor?",
      content: `We're in beta now so anyone can opt to be a mentor but after this a mentor can only be invited by referral system through existing mentors on Dev colony. Every mentor will get three invites per head. After referral, our team will go through the mentor’s profile and share the response by email.`,
    },
    {
      title: "How long is the review process for a mentor application?",
      content: `It takes atleast 12 hours to review a mentor application inorder to verify the mentors information.`,
    },
    {
      title: "What are the criteria to be a mentor on Dev Colony?",
      content: `Mentors on Dev Colony should have expertise in any of the techs with valuable work experience to support the growth and development of mentees. One of the most important norms is the willingness to mentor others.`,
    },
  ];

  return (
    <div>
      <Header />
      <div className="container px-5 sm:px-40 py-12 sm:py-20 mx-auto">
        <h1 className="text-4xl font-bold mb-2">FAQ</h1>
        <h4 className="mb-4">Frequently asked questions by our community</h4>
        <hr />
        <div className="">
          {accordionData.map(({ title, content }) => (
            <Accordion title={title} content={content} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default FAQ;
